import { useCampaignsStore } from "./store";
import { SquareLoader } from "screens/Main/components/Loader/SquareLoader";
import { Tabs, Tab } from "@heroui/tabs";
import { CampaignsTabsEnum } from "./types";
import { CampaignsPanel } from "./components/TabPanel/CampaignsPanel";
import { ProjectsPanel } from "./components/TabPanel/ProjectsPanel";
import { TasksPanel } from "./components/TabPanel/TasksPanel";

export const Campaigns = () => {
  const { isLoading, selectedTab, setSelectedTab } = useCampaignsStore();

  const handleTabChange = (key: CampaignsTabsEnum) => {
    setSelectedTab(key);
  };

  return (
    <div className="px-[14px] sm:px-[154px] flex flex-col items-center">
      <h1 className="mb-[50px] text-[24px] text-center px-[50px] sm:px-0 md:text-[36px] font-[700] capitalize">
        {selectedTab} Admin Panel
      </h1>
      <div className="w-full">
        {isLoading ? (
          <div className="flex w-full my-[20px] justify-center items-center">
            <SquareLoader size={32} />
          </div>
        ) : (
          <div className="flex w-full flex-col items-center">
            <Tabs
              aria-label="Options"
              selectedKey={selectedTab}
              onSelectionChange={handleTabChange}
            >
              <Tab
                key={CampaignsTabsEnum.CAMPAIGNS}
                title="Campaigns"
                className="w-full"
              >
                <CampaignsPanel />
              </Tab>
              <Tab
                key={CampaignsTabsEnum.PROJECTS}
                title="Projects"
                className="w-full"
              >
                <ProjectsPanel />
              </Tab>
              <Tab
                key={CampaignsTabsEnum.TASKS}
                title="Tasks"
                className="w-full"
              >
                <TasksPanel />
              </Tab>
            </Tabs>
          </div>
        )}
      </div>
    </div>
  );
};
